module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui container view"
  }, [_c('div', {
    staticClass: "ui two column centered grid"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "ui raised segment"
  }, [(_vm.flashIsActive) ? _c('div', {
    staticClass: "ui message",
    class: _vm.flash.type
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n            " + _vm._s(_vm._f("capitalize")(_vm.flash.type)) + "\n          ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.flash.message))])]) : _c('div', {
    staticClass: "ui icon message"
  }, [_c('i', {
    staticClass: "notched circle loading icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n              Just one second\n            ")]), _vm._v(" "), _c('p', [_vm._v("Loading the quote for you right now...")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c8451e38!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/Edit.vue
// module id = 224
// module chunks = 2